import { TeamSource } from "./TeamSource";

export type BracketMatch = {
  isFinal: boolean;
  isUpperFinal: boolean;
  matchId: string;
  resetMatchId?: string;
  teamOneSource: string;
  teamTwoSource: string;
  teamSources: TeamSource[];
};

export const isSeedSource = (source: string | TeamSource) => {
  return typeof source === "string"
    ? source.startsWith("Seed")
    : source.source.startsWith("Seed");
};
